import { FC } from "react";

import { Divider } from "antd";

import { ErrorLogs, StandSettings } from "@/components";

const SettingsPage: FC = () => {
  return (
    <div data-testid="settings-page">
      <Divider orientation="left">Stand</Divider>
      <StandSettings />
      <Divider orientation="left">Error logs</Divider>
      <ErrorLogs />
    </div>
  );
};

export default SettingsPage;
